import { createSelector } from 'reselect';
import { getMachineSettings } from 'lib/selectors/getMachineSettings';

const getShiftHandoverEnabled = createSelector(
  [getMachineSettings],
  (machineSettings) => {
    return machineSettings?.shiftHandoverEnabled ?? false;
  }
);

export { getShiftHandoverEnabled };
